export const NEXT_ACTION_ID = 'nextActionId';
export const CONNECTION_TYPE = 'connectionType';
export const EDGE_TYPE = 'edgeType';